export enum Env {
    STAGE = "stage",
    PROD = "prod"
}